import { useState } from "react";
import usePersistedState from "../hooks/usePersistedState";

export function useDateRangePersisted(startDate: string, endDate: string) {
  const [startDateLocal, setStartDateLocal] = usePersistedState(
    "startDate",
    startDate
  );

  const [endDateLocal, setEndDateLocal] = usePersistedState("endDate", endDate);

  const [dateRange, setDateRange] = useState<[string, string]>(() => {
    const safeStart =
      startDateLocal && startDateLocal.trim() !== "" ? startDateLocal : "";
    const safeEnd =
      endDateLocal && endDateLocal.trim() !== "" ? endDateLocal : "";
    return [safeStart, safeEnd];
  });

  return {
    dateRange,
    setDateRange,
    startDateLocal,
    setStartDateLocal,
    endDateLocal,
    setEndDateLocal,
  };
}
